<template>
  <li
    class="q-menu-item-group"
  >
    <div
      class="q-menu-item-group__title"
      :style="getStyle"
    >
      <template v-if="!$slots.title">
        {{ title }}
      </template>
      <slot
        v-else
        name="title"
      />
    </div>
    <ul>
      <slot/>
    </ul>
  </li>
</template>
<script>
  export default {
    name: 'QMenuItemGroup',

    componentName: 'QMenuItemGroup',

    inject: ['rootMenu'],
    props: {
      title: {
        type: String,
        default: '-'
      },
      qMenuKey: {type: String, default: undefined}
    },
    data() {
      return {
        paddingLeft: 20,
      };
    },
    computed: {
      levelPadding() {
        let padding = 20;
        let parent = this.$parent;
        if (this.rootMenu.collapse) return 20;
        while (parent && parent.$options.componentName !== 'QMenu') {
          if (parent.$options.componentName === 'QSubmenu') {
            padding += 20;
          }
          parent = parent.$parent;
        }
        return padding;
      },
      getStyle() {
        let isRtl = this.$qt('direction') === 'rtl';

        const ret = {};

        if (isRtl) {
          ret.paddingRight = this.levelPadding + 'px';
        } else {
          ret.paddingLeft = this.levelPadding + 'px';
        }

        return ret;
      }
    },
    methods: {
    }
  };
</script>

